import React, { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { toast } from "sonner";
import { Tag, Loader2 } from "lucide-react";

export const AddressLabelsButton = () => {
  const [open, setOpen] = useState(false);
  const [groups, setGroups] = useState([]);
  const [gid, setGid] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (open) { api.get("/groups").then((r) => setGroups(r.data || [])).catch(() => {}); } }, [open]);
  const make = async () => {
    setBusy(true);
    try {
      const r = await api.get("/address-labels.pdf", { params: { group_id: gid }, responseType: "blob" });
      window.open(URL.createObjectURL(new Blob([r.data], { type: "application/pdf" })), "_blank");
      setOpen(false);
    } catch (err) {
      const t = err.response?.data instanceof Blob ? JSON.parse(await err.response.data.text()).detail : err.response?.data?.detail;
      toast.error(apiError(t));
    } finally { setBusy(false); }
  };
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button data-testid="address-labels-btn" variant="outline" className="border-gold/40 text-gold hover:bg-gold/15 font-semibold gap-2"><Tag className="w-4 h-4" /> Address Labels</Button>
      </DialogTrigger>
      <DialogContent className="bg-[#05261D] border-gold/20" data-testid="address-labels-dialog">
        <DialogHeader><DialogTitle className="font-serif text-gold flex items-center gap-2"><Tag className="w-5 h-5" /> Print Address Labels</DialogTitle></DialogHeader>
        <p className="text-xs text-muted-foreground">Makes an A4 sheet of 14 cut-out labels (To: name, full address, mobile; From: Bengal Umrah House) for posting ihram kits and documents. Only customers who have saved a full address are included.</p>
        <select data-testid="address-labels-group" value={gid} onChange={(e) => setGid(e.target.value)} className="h-10 rounded-md border border-gold/30 bg-card/60 px-2 text-sm text-white">
          <option value="">All customers with an address</option>
          {groups.map((g) => <option key={g.id} value={g.id}>{g.name}{g.date ? ` · ${g.date}` : ""}</option>)}
        </select>
        <Button onClick={make} disabled={busy} data-testid="address-labels-print-btn" className="bg-gold text-[#0a2e22] hover:bg-gold/90 font-semibold gap-2">
          {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Tag className="w-4 h-4" />} Make labels (PDF)
        </Button>
      </DialogContent>
    </Dialog>
  );
};
